import React, { useState, FC } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import profile from "assets/image/profile.png";
import DarkMode from "components/theme";
import cn from "classnames";
import "assets/styles/components/navbar.scss";
import "assets/styles/components/button.scss";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const { t } = useTranslation();
  const location = useLocation();
  return (
    <div>
      <Navbar
        expand="md"
        className={cn("navbar navbar-light fixed-top navbar ")}
      >
        <NavbarBrand href="/">{t("logo")}</NavbarBrand>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav
            navbar
            className={cn(
              "w-100 d-flex nav  justify-content-center align-items-center"
            )}
          >
            <NavItem>
              <NavLink
                exact={true}
                activeClassName={"nav nav-link--selected"}
                className={
                  location.pathname === "/userView" ? " nav-link--selected" : ""
                }
                to="/userView"
              >
                {t("User view")}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={
                  location.pathname === "/wallet" ? " nav-link--selected" : ""
                }
                href="/wallet"
              >
                {t("Wallet")}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={
                  location.pathname === "/report" ? " nav-link--selected" : ""
                }
                href="/report"
              >
                {t("Reports")}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={
                  location.pathname === "/buySell" ? " nav-link--selected" : ""
                }
                href="/buySell"
              >
                {t("BuyAndSell")}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={
                  location.pathname === "/setting" ? " nav-link--selected" : ""
                }
                href="/setting"
              >
                {t("Settings")}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={
                  location.pathname === "/support" ? " nav-link--selected" : ""
                }
                href="/support"
              >
                {t("Support")}
              </NavLink>
            </NavItem>
          </Nav>
        </Collapse>
        <NavLink href="#">
          <i className="icon-search" />
        </NavLink>
        <NavLink href="#">
          <i className="icon-bell" />
        </NavLink>
        <NavLink href="#">
          <DarkMode />
        </NavLink>
        <NavLink href="#">
          <img src={profile} alt="profile" className="rounded-pill" />
        </NavLink>
      </Navbar>
    </div>
  );
};

export default Header;
